<template>
  <b-modal
    id="new_group"
    title="Novo grupo"
    hide-footer
    @show="resetModal"
    @shown="$refs.autofocus.focus()"
  >
    <b-overlay :show="loading" opacity="0.99">
      <form @submit="create">
        <WarningRequiredFields />
        <ErrorsMessages :errors="errors" />
        <div class="form-group">
          <LabelRequiredField label="Nome" />
          <input
            type="text"
            ref="autofocus"
            class="form-control"
            v-model="name"
          />
        </div>
        <div class="form-group text-right">
          <v-btn type="submit" class="v-success">
            <span class="fa fa-check"></span> Salvar
          </v-btn>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import WarningRequiredFields from "../components/WarningRequiredFields";
import ErrorsMessages from "../components/ErrorsMessages";
import LabelRequiredField from "../components/LabelRequiredField";

import api from "../../services/api";
import toast from "../../components/ToastNotification";

export default {
  name: "NewGroup",
  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },
  data() {
    return {
      errors: [],

      loading: false,

      name: "",
    };
  },
  methods: {
    async resetModal() {
      this.errors = [];
      this.name = "";
    },
    async create(ev) {
      try {
        ev.preventDefault();
        this.loading = true;

        let params = { name: this.name };
        let response = await api.post("/admin/permission/group", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("new_group");
          this.$emit("created");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>